function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 49,
  r: 8,
  fill: "#7E7AD2"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 202,
  cy: 75,
  r: 8,
  fill: "#7E7AD2"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 39,
  r: 8,
  fill: "#7E7AD2"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 54,
  r: 8,
  fill: "#7E7AD2"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 83,
  r: 8,
  fill: "#7E7AD2"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 121,
  r: 8,
  fill: "#7E7AD2"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 162,
  r: 8,
  fill: "#7E7AD2"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 196,
  r: 8,
  fill: "#7E7AD2"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 211,
  r: 8,
  fill: "#7E7AD2"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 208,
  r: 8,
  fill: "#7E7AD2"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 195,
  cy: 189,
  r: 8,
  fill: "#7E7AD2"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 179.5,
  cy: 20.5,
  r: 10.5,
  fill: "#69E9F5"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 123.5,
  cy: 10.5,
  r: 10.5,
  fill: "#69E9F5"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 67.5,
  cy: 27.5,
  r: 10.5,
  fill: "#69E9F5"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 27.5,
  cy: 66.5,
  r: 10.5,
  fill: "#69E9F5"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 10.5,
  cy: 120.5,
  r: 10.5,
  fill: "#69E9F5"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.5,
  cy: 175.5,
  r: 10.5,
  fill: "#69E9F5"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 56.5,
  cy: 220.5,
  r: 10.5,
  fill: "#69E9F5"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 108.5,
  cy: 242.5,
  r: 10.5,
  fill: "#69E9F5"
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 166.5,
  cy: 239.5,
  r: 10.5,
  fill: "#69E9F5"
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 215.5,
  cy: 210.5,
  r: 10.5,
  fill: "#69E9F5"
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  cx: 225.5,
  cy: 55.5,
  r: 10.5,
  fill: "#69E9F5"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M306.715 140.272C306.715 147.591 305.933 154.575 304.369 161.224C302.86 167.817 300.402 173.628 296.993 178.657C293.641 183.63 289.283 187.597 283.919 190.558C278.611 193.519 272.185 195 264.642 195H229.107V85.6272H264.642C272.074 85.6272 278.443 87.1358 283.751 90.153C289.115 93.1143 293.473 97.0813 296.826 102.054C300.234 107.027 302.72 112.81 304.285 119.403C305.905 125.996 306.715 132.952 306.715 140.272ZM289.367 140.272C289.367 127.644 287.215 118.006 282.913 111.357C278.611 104.652 272.521 101.3 264.642 101.3H246.456V179.411H264.642C272.521 179.411 278.611 176.003 282.913 169.186C287.215 162.37 289.367 152.732 289.367 140.272ZM334.624 162.565C335.462 167.929 338.005 172.399 342.251 175.975C346.553 179.495 352.308 181.255 359.516 181.255C365.159 181.255 370.048 180.389 374.183 178.657C378.373 176.869 381.977 174.522 384.994 171.617L393.878 183.853C388.85 188.882 383.514 192.318 377.87 194.162C372.283 196.006 366.165 196.928 359.516 196.928C353.482 196.928 347.866 195.922 342.67 193.91C337.474 191.899 332.976 189.105 329.177 185.529C325.377 181.898 322.388 177.595 320.209 172.623C318.086 167.65 317.024 162.118 317.024 156.028C317.024 150.105 318.002 144.658 319.957 139.685C321.969 134.656 324.763 130.326 328.338 126.694C331.97 123.007 336.3 120.157 341.329 118.146C346.358 116.078 351.917 115.045 358.007 115.045C364.321 115.045 370.048 116.134 375.189 118.313C380.329 120.437 384.715 123.538 388.347 127.616C392.034 131.695 394.912 136.696 396.979 142.618C399.047 148.485 400.08 155.134 400.08 162.565H334.624ZM380.469 147.312C379.575 142.283 376.976 138.26 372.674 135.243C368.372 132.17 363.483 130.633 358.007 130.633C352.532 130.633 347.615 132.17 343.257 135.243C338.899 138.26 336.273 142.283 335.379 147.312H380.469ZM490.512 116.889L461.681 195H441.231L412.4 116.889H430.923L451.54 175.975L471.99 116.889H490.512ZM585.721 195H563.762L535.434 150.748H527.556V195H510.207V85.6272H546.246C558.259 85.6272 567.59 88.393 574.239 93.9245C580.888 99.4001 584.212 107.53 584.212 118.313C584.212 123.118 583.458 127.365 581.949 131.053C580.496 134.684 578.401 137.813 575.663 140.439C572.981 143.065 569.825 145.161 566.193 146.725C562.617 148.234 558.734 149.267 554.543 149.826L585.721 195ZM566.863 118.062C566.863 112.475 565.019 108.284 561.332 105.49C557.7 102.697 552.671 101.3 546.246 101.3H527.556V135.075H546.246C552.671 135.075 557.7 133.679 561.332 130.885C565.019 128.091 566.863 123.817 566.863 118.062ZM599.466 172.539C599.466 167.957 600.695 163.962 603.153 160.554C605.612 157.09 608.824 154.212 612.792 151.921C616.814 149.631 621.396 147.926 626.536 146.809C631.733 145.636 637.013 145.049 642.377 145.049C645.338 145.049 647.88 145.105 650.003 145.217C652.127 145.328 654.278 145.496 656.457 145.719V142.618C656.457 138.54 654.864 135.494 651.68 133.483C648.551 131.472 644.416 130.466 639.276 130.466C634.582 130.466 629.805 131.136 624.944 132.477C620.083 133.762 615.473 135.662 611.115 138.176L604.075 124.599C609.216 121.638 614.719 119.319 620.586 117.643C626.509 115.911 632.738 115.045 639.276 115.045C643.522 115.045 647.685 115.52 651.763 116.469C655.898 117.419 659.586 118.984 662.826 121.163C666.123 123.342 668.749 126.192 670.705 129.712C672.66 133.176 673.638 137.478 673.638 142.618V195H656.457V183.518C653.719 187.764 649.668 191.061 644.304 193.408C638.996 195.754 633.269 196.928 627.123 196.928C623.324 196.928 619.72 196.397 616.312 195.335C612.959 194.33 610.054 192.793 607.595 190.726C605.137 188.658 603.153 186.116 601.645 183.099C600.192 180.026 599.466 176.506 599.466 172.539ZM631.565 181.423C634.973 181.423 638.158 181.004 641.119 180.166C644.137 179.272 646.791 178.07 649.081 176.562C651.372 174.997 653.16 173.125 654.445 170.946C655.786 168.767 656.457 166.365 656.457 163.739V160.805C653.719 160.358 651.149 160.107 648.746 160.051C646.344 159.995 644.22 159.967 642.377 159.967C633.884 159.967 627.458 161.085 623.1 163.32C618.798 165.555 616.647 168.32 616.647 171.617C616.647 178.154 621.62 181.423 631.565 181.423ZM767.506 195H750.157V187.792C746.805 190.754 743.424 193.016 740.016 194.581C736.608 196.145 732.724 196.928 728.366 196.928C723.338 196.928 718.672 195.922 714.37 193.91C710.068 191.899 706.352 189.105 703.223 185.529C700.15 181.898 697.72 177.567 695.932 172.539C694.2 167.51 693.333 162.007 693.333 156.028C693.333 150.105 694.2 144.63 695.932 139.601C697.72 134.517 700.15 130.186 703.223 126.611C706.352 122.979 710.068 120.157 714.37 118.146C718.672 116.078 723.338 115.045 728.366 115.045C732.724 115.045 736.608 115.799 740.016 117.308C743.424 118.76 746.805 120.967 750.157 123.929V101.3H735.071V85.6272H767.506V195ZM750.157 137.674C748.09 135.383 745.408 133.651 742.111 132.477C738.871 131.248 735.77 130.633 732.808 130.633C726.271 130.633 720.935 132.98 716.8 137.674C712.722 142.367 710.682 148.485 710.682 156.028C710.682 163.571 712.722 169.661 716.8 174.299C720.935 178.936 726.271 181.255 732.808 181.255C735.77 181.255 738.871 180.668 742.111 179.495C745.408 178.266 748.09 176.506 750.157 174.215V137.674ZM786.866 172.539C786.866 167.957 788.095 163.962 790.554 160.554C793.012 157.09 796.225 154.212 800.192 151.921C804.215 149.631 808.796 147.926 813.937 146.809C819.133 145.636 824.413 145.049 829.777 145.049C832.738 145.049 835.281 145.105 837.404 145.217C839.527 145.328 841.678 145.496 843.857 145.719V142.618C843.857 138.54 842.265 135.494 839.08 133.483C835.951 131.472 831.816 130.466 826.676 130.466C821.983 130.466 817.205 131.136 812.344 132.477C807.483 133.762 802.874 135.662 798.516 138.176L791.476 124.599C796.616 121.638 802.12 119.319 807.986 117.643C813.909 115.911 820.139 115.045 826.676 115.045C830.922 115.045 835.085 115.52 839.164 116.469C843.299 117.419 846.986 118.984 850.227 121.163C853.523 123.342 856.149 126.192 858.105 129.712C860.061 133.176 861.038 137.478 861.038 142.618V195H843.857V183.518C841.119 187.764 837.069 191.061 831.705 193.408C826.397 195.754 820.67 196.928 814.524 196.928C810.724 196.928 807.12 196.397 803.712 195.335C800.36 194.33 797.454 192.793 794.996 190.726C792.537 188.658 790.554 186.116 789.045 183.099C787.592 180.026 786.866 176.506 786.866 172.539ZM818.965 181.423C822.374 181.423 825.559 181.004 828.52 180.166C831.537 179.272 834.191 178.07 836.482 176.562C838.773 174.997 840.561 173.125 841.846 170.946C843.187 168.767 843.857 166.365 843.857 163.739V160.805C841.119 160.358 838.549 160.107 836.147 160.051C833.744 159.995 831.621 159.967 829.777 159.967C821.284 159.967 814.859 161.085 810.501 163.32C806.198 165.555 804.047 168.32 804.047 171.617C804.047 178.154 809.02 181.423 818.965 181.423ZM957.085 135.411C955.018 134.405 952.895 133.651 950.716 133.148C948.593 132.589 946.134 132.31 943.34 132.31C939.485 132.31 935.853 132.896 932.445 134.07C929.093 135.187 926.187 136.891 923.729 139.182C921.27 141.473 919.343 144.35 917.946 147.815C916.605 151.223 915.934 155.274 915.934 159.967V179.411H933.451V195H880.902V179.411H898.586V132.561H880.902V116.889H915.934V136.5C918.784 128.678 922.974 123.146 928.506 119.906C934.093 116.665 940.714 115.045 948.369 115.045C950.772 115.045 953.286 115.296 955.912 115.799C958.538 116.302 961.108 117.196 963.623 118.481L957.085 135.411Z",
  fill: "#40356F"
});

function SvgLogoFirstDraft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1102,
    height: 253,
    viewBox: "0 0 1102 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFirstDraft);
export default __webpack_public_path__ + "static/media/Logo_first_draft.26d2fd01.svg";
export { ForwardRef as ReactComponent };